import { render } from "./BeneficiosFiscalizacao.vue?vue&type=template&id=13850c7f"
import script from "./BeneficiosFiscalizacao.vue?vue&type=script&lang=js"
export * from "./BeneficiosFiscalizacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__